export const iconFontAwesomeEditingLinkSlash = (
	<i className="fa-solid fa-link-slash"></i>
);
